import { bswap } from './bswap';
function isBigEndianFactory() {
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    const isBigEndian = !((view[0] = 1) & array[0]);
    return () => isBigEndian;
}
const isBigEndian = isBigEndianFactory();
export function asLittleEndianByteArray(array, bigEndian = isBigEndian()) {
    let databuffer;
    if (bigEndian) {
        // Create a clone as we don't want to alter data
        const clone = array.slice(0);
        // Swap bytes to little-endian
        bswap(clone);
        databuffer = clone;
    }
    else {
        databuffer = array;
    }
    const bytes = databuffer.buffer.slice(databuffer.byteOffset, databuffer.byteOffset + databuffer.byteLength);
    return new Uint8Array(bytes);
}
export function fixEndianness(array, bigEndian = isBigEndian()) {
    if (bigEndian) {
        bswap(array);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi91dGlscy9hcnJheXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUcvQixTQUFTLGtCQUFrQjtJQUN6QixNQUFNLEtBQUssR0FBRyxJQUFJLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUMvQixNQUFNLElBQUksR0FBRyxJQUFJLFdBQVcsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUE7SUFDMUMsTUFBTSxXQUFXLEdBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBRS9DLE9BQU8sR0FBRyxFQUFFLENBQUMsV0FBVyxDQUFBO0FBQzFCLENBQUM7QUFFRCxNQUFNLFdBQVcsR0FBRyxrQkFBa0IsRUFBRSxDQUFBO0FBRXhDLE1BQU0sVUFBVSx1QkFBdUIsQ0FDckMsS0FBaUIsRUFDakIsU0FBUyxHQUFHLFdBQVcsRUFBRTtJQUV6QixJQUFJLFVBQVUsQ0FBQTtJQUNkLElBQUksU0FBUyxFQUFFO1FBQ2IsZ0RBQWdEO1FBQ2hELE1BQU0sS0FBSyxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7UUFDNUIsOEJBQThCO1FBQzlCLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUNaLFVBQVUsR0FBRyxLQUFLLENBQUE7S0FDbkI7U0FBTTtRQUNMLFVBQVUsR0FBRyxLQUFLLENBQUE7S0FDbkI7SUFDRCxNQUFNLEtBQUssR0FBRyxVQUFVLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FDbkMsVUFBVSxDQUFDLFVBQVUsRUFDckIsVUFBVSxDQUFDLFVBQVUsR0FBRyxVQUFVLENBQUMsVUFBVSxDQUM5QyxDQUFBO0lBQ0QsT0FBTyxJQUFJLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQTtBQUM5QixDQUFDO0FBRUQsTUFBTSxVQUFVLGFBQWEsQ0FBQyxLQUFpQixFQUFFLFNBQVMsR0FBRyxXQUFXLEVBQUU7SUFDeEUsSUFBSSxTQUFTLEVBQUU7UUFDYixLQUFLLENBQUMsS0FBSyxDQUFDLENBQUE7S0FDYjtBQUNILENBQUMifQ==